export class S3DetectPartitionsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "samplePaths",
            "baseName": "samplePaths",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3DetectPartitionsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
